export default __webpack_public_path__ + "static/media/cariaus-album-1.d8e72f3d.svg";